"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var store_1 = require("../../../app/store");
var sleepService_1 = require("../../../app/services/sleepService");
var components_1 = require("../../../youwell-common/components");
var urls_1 = __importDefault(require("../../../app/urls"));
var SleepDiary_1 = __importDefault(require("./SleepDiary"));
var LogDay_1 = __importDefault(require("./LogDay"));
var Index = function () {
    var dispatch = (0, store_1.useYouwellDispatch)();
    var sleepEntries = (0, store_1.useYouwellSelector)(function (state) { return state.sleepDataStore.entries; });
    React.useEffect(function () {
        if (!sleepEntries) {
            var startDate = new Date();
            startDate.setMonth(startDate.getMonth() - 1);
            (0, sleepService_1.fetchEntriesData)(dispatch, { startDate: startDate });
        }
    }, [dispatch, sleepEntries]);
    if (!sleepEntries) {
        return null;
    }
    return (React.createElement(react_router_dom_1.Switch, null,
        React.createElement(react_router_dom_1.Route, { path: "".concat(urls_1.default.inside.pages.sleepDiary, "/log/:date"), component: LogDay_1.default }),
        React.createElement(react_router_dom_1.Route, { path: "".concat(urls_1.default.inside.pages.sleepDiary) },
            React.createElement(SleepDiary_1.default, null)),
        React.createElement(react_router_dom_1.Route, { component: components_1.PageNotFound })));
};
exports.default = Index;
